import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { Input } from "@ventumsoftware/react-toolkit";
import moment from "moment/moment";
import React, { type FC, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import type { DefaultInspectionAttachment } from "../api/dto";
import { ModalFooter } from "../components/layout/ModalProvider";

export const EditDefaultInspectionAttachmentModal: FC<{
  attachment: DefaultInspectionAttachment;
  reload: (silently: boolean) => Promise<void>;
}> = (props) => {
  const { editDefaultInspectionAttachment } = useApiCall();

  const [name, setName] = useState<string>(props.attachment.name ?? "");
  const [order, setOrder] = useState<number>(props.attachment.order ?? 1);
  const [fromDate, setFromDate] = useState<Date>(
    props.attachment.fromDate ? new Date(props.attachment.fromDate) : new Date(),
  );
  const [toDate, setToDate] = useState<Date>(
    props.attachment.toDate ? new Date(props.attachment.toDate) : new Date(),
  );
  const [errors, setErrors] = useState<string[]>([]);

  const save = async () => {
    await editDefaultInspectionAttachment(props.attachment.id, name, order, fromDate, toDate)
      .catch((e) => {
        if (e instanceof ValidationError) {
          setErrors(Object.values(e.errors).flat());
        }
        throw e;
      })
      .then(() => {
        props.reload(true);
      });
  };

  return (
    <>
      <div className={"flex flex-col gap-y-4"}>
        <div className={"grid grid-cols-4 gap-4"}>
          <div className={"col-span-3"}>
            <Input type={"text"} label={"Naam"} value={name} onChange={setName} />
          </div>
          <div className={"col-span-1"}>
            <Input
              type={"number"}
              label={"Volgorde"}
              value={order}
              onChange={setOrder}
              min={1}
              step={1}
            />
          </div>
        </div>

        <div className={"grid grid-cols-2 gap-4"}>
          <div>
            <Input type={"date"} label={"Vanaf"} value={fromDate} onChange={setFromDate} />
          </div>
          <div>
            <Input type={"date"} label={"Tot en met"} value={toDate} onChange={setToDate} />
          </div>
        </div>
      </div>

      <ModalFooter text={"Opslaan"} icon={faUpload} onSubmit={save} />
    </>
  );
};
